import React from "react";
import styled from "@emotion/styled";

const Intro = (props) => {
  const Hi = styled.div`
    margin-top: 10vh;
    font-size: 10vh;
    animation-duration: 3s;
    color: white;
    @media (max-width: 1100px) {
      font-size: 120%;
    }
  `;

  const Gray = styled.span`
    color: #197aea;
  `;
  return (
    <Hi className="animated fadeIn">
      Hi! My name is Kyle and I've developed a Java application that uses{" "}
      <Gray>neural networks to teach an AI how to drive</Gray> through an
      intersection.
    </Hi>
  );
};

export default Intro;
